export default "__VITE_ASSET__d73a198a__"